export function normalizeEmail(value) {
  return value.trim().toLowerCase();
}

export function validateEmail(value) {
  const normalized = normalizeEmail(value);

  if (!normalized) {
    return "El email es obligatorio.";
  }

  if (normalized.length > 254) {
    return "El email es demasiado largo.";
  }

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized)) {
    return "Ingresá un email válido.";
  }

  return "";
}
